var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckedIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "11px",
    height: "9px",
    viewBox: "0 0 11 9",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "65A9DEC6-A838-4B49-8F13-51ABADD8E352") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u05E2\\u05DE\\u05D5\\u05D3-\\u05DC\\u05D9\\u05D3\\u05D9\\u05DD-\\u05DE\\u05D5\\u05D1\\u05D9\\u05D9\\u05DC",
    transform: "translate(-289.000000, -991.000000)",
    stroke: "#2E2D79",
    strokeWidth: 1.512
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-4",
    points: "290 996.390706 292.989115 999.202381 296.654466 994.928964 299.166667 992"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckedIcon);
export default __webpack_public_path__ + "static/media/checked-icon.de006d140073a77faf8a89e30616f17f.svg";
export { ForwardRef as ReactComponent };